<template>
  <EvaluatorLayout title="Seu perfil" menu="Account">
    <title>Seu perfil</title>
    <div class="col-lg-12 container-form" style="">
      <div class="block_header w-70 h-fixed">
        <span style="font-size: 20px">{{ name }}</span>
      </div>
      <div class="mt-3 account-container w-70">
        <div class="inputs-container">
          <div class="center position-relative">
            <img
              :src="picture ? picture : '/images/avatar.png'"
              alt="profile-picture"
            />
            <div class="input-image">
              <label for="image-input">
                <font-awesome-icon
                  for="image-input"
                  icon="plus"
                  size="2x"
                  title="Trocar foto"
                />
              </label>
              <input
                type="file"
                :ref="`file`"
                v-on:change="sendImageUpload()"
                accept="image/png, image/jpeg"
                id="image-input"
                capture="camcorder"
                class="d-none"
              />
            </div>
          </div>
          <div class="input mt-5 w-100">
            <span v-bind:class="$v.name.$error ? 'text-danger' : ''"
              >NOME:</span
            >
            <input
              type="text"
              class="form-control form__input"
              v-model="$v.name.$model"
              minlength="4"
              required
            />
            <div class="text-danger" v-if="!$v.name.required">
              CAMPO NÃO DEVE ESTAR VAZIO
            </div>
            <div class="text-danger" v-if="!$v.name.minLength">
              NOME DEVE POSSUIR NO MÍNIMO
              {{ $v.name.$params.minLength.min }}CARACTERES.
            </div>
          </div>
          <div class="input mt-custom w-100">
            <span v-bind:class="$v.email.$error ? 'text-danger' : ''"
              >EMAIL:</span
            >
            <input
              type="email"
              class="form-control"
              v-model="$v.email.$model"
              minlength="10"
              required
            />
            <div class="text-danger" v-if="!$v.email.required">
              CAMPO NÃO DEVE ESTAR VAZIO
            </div>
            <div class="text-danger" v-if="!$v.email.minLength">
              NOME DEVE POSSUIR NO MÍNIMO
              {{ $v.name.$params.minLength.min }}CARACTERES.
            </div>
          </div>
          <div class="input mt-custom w-100">
            <span v-bind:class="$v.phone.$error ? 'text-danger' : ''"
              >CELULAR:</span
            >
            <input
              type="tel"
              class="form-control"
              :class="!$v.phone.$error ? '' : 'is-invalid'"
              v-model="$v.phone.$model"
              v-mask="['+## (##) ####-####', '+## (##) #####-####']"
              required
            />
            <div class="text-danger" v-if="!$v.phone.required">
              CAMPO NÃO DEVE ESTAR VAZIO
            </div>
            <div class="text-danger" v-if="!$v.phone.minLength">
              O telefone deve possuir no minimo
              {{ $v.phone.$params.minLength.min }} digitos.
            </div>
          </div>
          <div class="input mt-custom w-100">
            <span>NOME DA EMPRESA:</span>
            <input type="text" class="form-control" v-model="business_name" />
          </div>
        </div>
        <div class="inputs-container mt-3">
          <div class="input w-100">
            <span v-bind:class="$v.password.$error ? 'text-danger' : ''"
              >SENHA ATUAL:</span
            >
            <input
              type="password"
              class="form-control"
              v-model="$v.password.$model"
              minlength="6"
            />
            <password
              v-model="$v.password.$model"
              :strength-meter-only="true"
              v-if="$v.password.$model.length > 0"
            />
            <div class="text-danger" v-if="!$v.password.minLength">
              A SENHA DEVE TER NO MÍNIMO
              {{ $v.password.$params.minLength.min }} CARACTERES.
            </div>
          </div>
          <div class="input mt-custom w-100">
            <span
              v-bind:class="[
                !$v.new_password.minLength ||
                !$v.new_password_confirmation.sameAsNewPassword
                  ? 'text-danger'
                  : '',
              ]"
            >
              NOVA SENHA:
            </span>
            <input
              type="password"
              class="form-control"
              :class="[
                $v.new_password_confirmation.sameAsNewPassword
                  ? ''
                  : 'is-invalid',
              ]"
              v-model="$v.new_password.$model"
              minlength="6"
            />
            <password
              v-model="$v.new_password.$model"
              :strength-meter-only="true"
              v-if="$v.new_password.$model.length > 0"
            />
            <div class="text-danger" v-if="!$v.new_password.minLength">
              A NOVA SENHA DEVE TER NO MÍNIMO
              {{ $v.new_password.$params.minLength.min }} CARACTERES.
            </div>
          </div>
          <div class="input mt-custom w-100">
            <span
              v-bind:class="
                $v.new_password_confirmation.$error ? 'text-danger' : ''
              "
              >CONFIRMAR NOVA SENHA:</span
            >
            <input
              type="password"
              class="form-control"
              :class="[
                $v.new_password_confirmation.sameAsNewPassword
                  ? ''
                  : 'is-invalid',
              ]"
              v-model="$v.new_password_confirmation.$model"
              minlength="6"
            />
            <password
              v-model="$v.new_password_confirmation.$model"
              :strength-meter-only="true"
              v-if="$v.new_password_confirmation.$model.length > 0"
            />
            <div
              class="text-danger"
              v-if="!$v.new_password_confirmation.sameAsNewPassword"
            >
              AS DUAS SENHAS NÃO COINCIDEM
            </div>
            <div
              class="text-danger"
              v-if="!$v.new_password_confirmation.minLength"
            >
              A CONFIRMAÇÃO DA NOVA SENHA DEVE TER NO MÍNIMO
              {{ $v.new_password_confirmation.$params.minLength.min }}
              CARACTERES.
            </div>
            <div class="mt-3">
              <SwitchCheckbox
                  v-model="receive_emails"
                  :value="receive_emails"
                  label="Receber Emails?"
              />
          </div>
          </div>
        </div>
        <button
          class="btn full btn-degrade normal-degrade mt-3"
          @click="handleUpdate"
        >
          SALVAR ALTERAÇÕES
        </button>
      </div>
    </div>
  </EvaluatorLayout>
</template>

<script>
import { mask } from "vue-the-mask";
import Password from "vue-password-strength-meter";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import axios from "axios";
import SwitchCheckbox from "../Jobs/SwitchCheckbox.vue";
import EvaluatorLayout from "layouts/Evaluator.vue";

export default {
  name: "algo",
  props: [
    "recruiter_name",
    "recruiter_email",
    "recruiter_phone",
    "recruiter_business_name",
    "recrutier_picture",
    "recruiter_receive_emails"
  ],
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      business_name: "",
      password: "",
      new_password: "",
      new_password_confirmation: "",
      picture: "",
      receive_emails:""
    };
  },
  components: {
    Password,
    SwitchCheckbox,
    EvaluatorLayout,
},
  validations: {
    name: {
      required,
      minLength: minLength(4),
    },
    email: {
      required,
      minLength: minLength(10),
    },
    phone: {
      required,
      minLength: minLength(10),
    },
    password: {
      minLength: minLength(6),
    },
    new_password: {
      minLength: minLength(6),
    },
    new_password_confirmation: {
      minLength: minLength(6),
      sameAsNewPassword: sameAs("new_password"),
    },
  },
  directives: {
    mask,
  },
  mounted() {
    this.name = this.recruiter_name;
    this.email = this.recruiter_email;
    this.phone = this.recruiter_phone;
    this.business_name = this.recruiter_business_name;
    this.receive_emails = this.recruiter_receive_emails;
    localStorage.getItem("avatar-url")
      ? (this.picture = localStorage.getItem("avatar-url"))
      : false;
  },
  methods: {
    handleUpdate() {
      if (this.$v.$anyError) {
        this.$toast.error("Há erros no formulario.", {
          position: "top",
        });
        return;
      }
      let data = {
        recruiter: {
          name: this.name,
          email: this.email,
          mobile_phone: this.phone,
          business_name: this.business_name,
          receive_emails: this.receive_emails
        },
      };
      if (this.password !== "") {
        if (this.new_password === this.new_password_confirmation) {
          data.recruiter.password = this.new_password;
          data.recruiter.current_password = this.password;
        }
      }
      axios.put("/recruiters/profile", data).then((response) => {
        if (response.data.status === "true") {
          this.$toast.success("Dados salvos com sucesso!", {
            position: "top",
          });
          top.location.reload();
        } else {
          this.$toast.error(response.data.message, {
            position: "top",
          });
        }
      });
    },
    sendImageUpload() {
      let formData = new FormData();
      this.file = this.$refs["file"].files[0];
      formData.append("recruiter[picture]", this.file);

      axios
        .put("/recruiters/profile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const totalLength = progressEvent.lengthComputable
              ? progressEvent.total
              : progressEvent.target.getResponseHeader("content-length") ||
                progressEvent.target.getResponseHeader(
                  "x-decompressed-content-length"
                );

            if (totalLength !== null) {
              this.percent = parseInt(
                (progressEvent.loaded * 100) / totalLength
              );
            }
          },
        })
        .then((response) => {
          if (response.data.status === "true") {
            this.$toast.success("Avatar trocado com sucesso!", {
              position: "top",
            });
            localStorage.setItem("avatar-url", response.data.pictureURL);
            top.location.reload();
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>